export default __webpack_public_path__ + "static/logo-ranking-d3a1792a6056b6cae4ecb17c209e031f.svg";